export const DEFAULT_DATE_TIME_FORMAT = 'dd.MM.yyyy HH:mm';
export const DEFAULT_FULL_DATE_TIME_FORMAT = 'dd.MM.yyyy HH:mm:ss';
export const DEFAULT_DATE_FORMAT = 'dd.MM.yyyy';
export const BACKEND_DATE_FORMAT = 'yyyy-MM-dd';
export const DEFAULT_FULL_TIME_FORMAT = 'HH:mm:ss';
